import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

type Props = { API: string };
const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
const errOf = (e: any, d: string) => (e && e.response && e.response.data && e.response.data.detail) || d;
const btn: any = { padding: '5px 12px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' };
const fmt = (v: any) => { if (!v) return '—'; try { return new Date(v).toLocaleString('pl-PL'); } catch (e) { return String(v); } };

export default function AliOrdersPanel({ API }: Props) {
  const [st, setSt] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<any>(null);
  const load = () => { axios.get(API + '/settings/aliexpress/orders', { headers: auth() }).then((r: any) => setSt(r.data)).catch(() => setSt(null)); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [API]);
  const run = () => {
    setBusy(true); setMsg({ ok: null, text: '⏳ Pobieranie zamówień z AliExpress…' });
    axios.post(API + '/settings/aliexpress/orders/run', {}, { headers: auth() })
      .then((r: any) => { setSt(r.data); const i = r.data.import || {}; setMsg({ ok: !i.error, text: i.error ? '✕ ' + i.error : '✓ Gotowe — nowych zamówień: ' + (i.new || 0) + (i.status_changes ? ', zmian statusu: ' + i.status_changes : '') }); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się pobrać zamówień.') }))
      .finally(() => setBusy(false));
  };
  const setLive = (live: boolean) => {
    if (live && !window.confirm('Włączyć wysyłanie danych o przesyłce do AliExpress?\n\nPo podpięciu etykiety przez Pakowalnię OPENkontakt prześle do AliExpress numer przesyłki i przewoźnika — AliExpress oznaczy zamówienie jako wysłane.')) return;
    axios.post(API + '/settings/aliexpress/orders/live', { live: live }, { headers: auth() })
      .then((r: any) => { setSt(r.data); setMsg({ ok: true, text: live ? '✓ Wysyłanie danych o przesyłce włączone.' : '✓ Tryb podglądu (nic nie jest wysyłane).' }); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zmienić.') }));
  };
  if (!st) return null;
  const i = st.import || {};
  return (
    <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #e5e7eb', fontSize: 13 }}>
      <div style={{ fontWeight: 600, marginBottom: 6 }}>Zamówienia AliExpress</div>
      <div style={{ color: '#374151', marginBottom: 4 }}>Pobierane automatycznie co 10 minut — tylko nowe, złożone od: <b>{st.since || 'pierwszego przebiegu'}</b>.</div>
      <div style={{ color: '#6b7280', fontSize: 12, marginBottom: 8 }}>
        Ostatni przebieg: {fmt(i.at)}{i.error ? <span style={{ color: '#b91c1c' }}> · błąd: {String(i.error)}</span> : <span> · nowych: {i.new || 0} · zmian statusu: {i.status_changes || 0}{i.errors ? ' · błędów: ' + i.errors : ''}</span>}
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
        <button onClick={run} disabled={busy} style={{ ...btn, opacity: busy ? 0.5 : 1 }}>↻ Pobierz teraz</button>
        {msg ? <span style={{ fontSize: 12, fontWeight: 600, color: msg.ok === true ? '#15803d' : (msg.ok === false ? '#b91c1c' : '#6b7280') }}>{msg.text}</span> : null}
      </div>
      <div style={{ background: st.live ? '#f0fdf4' : '#fffbeb', border: '1px solid ' + (st.live ? '#bbf7d0' : '#fde68a'), borderRadius: 8, padding: '8px 12px' }}>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>Dane o wysyłce → AliExpress: {st.live ? 'WŁĄCZONE' : 'PODGLĄD (nic nie jest wysyłane)'}</div>
        <div style={{ fontSize: 12, color: '#374151', marginBottom: 6 }}>
          Po podpięciu etykiety przez Pakowalnię automat przesyła numer przesyłki i przewoźnika do AliExpress (pierwsza etykieta — całość, kolejne — część).
          {st.live ? '' : ' W podglądzie w notatce zamówienia pojawia się tylko informacja, co zostałoby wysłane.'}
        </div>
        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 6 }}>Wysłane: {st.fulfill.ok} · w podglądzie: {st.fulfill.preview} · błędy: {st.fulfill.error}</div>
        <button onClick={() => setLive(!st.live)} style={{ ...btn, borderColor: st.live ? '#fecdd3' : '#16a34a', color: st.live ? '#b91c1c' : '#15803d', fontWeight: 600 }}>{st.live ? 'Wyłącz (tylko podgląd)' : 'Włącz wysyłanie do AliExpress'}</button>
      </div>
    </div>
  );
}
